/**
 * Split a comma-separated email header value into individual addresses.
 *
 * A naive `value.split(',')` breaks on a quoted display name — the RFC 5322
 * form `"Doe, John" <j@x.com>` becomes two bogus recipients, `"Doe` and
 * `John" <j@x.com>`. Commas inside double quotes or inside angle brackets are
 * therefore not separators.
 */
export function splitAddressList(value) {
    if (typeof value !== 'string') return [];
    const out = [];
    let current = '';
    let inQuotes = false;
    let inAngles = false;
    for (const ch of value) {
        if (ch === '"') { inQuotes = !inQuotes; current += ch; continue; }
        if (!inQuotes && ch === '<') { inAngles = true; current += ch; continue; }
        if (!inQuotes && ch === '>') { inAngles = false; current += ch; continue; }
        if (ch === ',' && !inQuotes && !inAngles) { out.push(current); current = ''; continue; }
        current += ch;
    }
    out.push(current);
    return out.map(s => s.trim()).filter(Boolean);
}

/**
 * The bare address inside `Name <a@b>`, or the input trimmed when it is
 * already bare.
 *
 * The personal Outlook sync stores `from_email` in DISPLAY form
 * (`"Name <a@b>"`), and Graph rejects a display form at send time — so every
 * recipient the composer seeds goes through here before it reaches a send
 * payload. `splitAddressList` only guarantees comma-safe SPLITTING; it does
 * not strip the display form, which is why this exists rather than reusing it.
 */
export function extractAddress(value) {
    const s = String(value || '').trim();
    if (!s) return '';
    const m = s.match(/<([^<>]+@[^<>]+)>\s*$/);
    return (m ? m[1] : s).trim().toLowerCase();
}
